import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CANCEL_ERROR } from 'apisauce';

import { toggleFavourite } from '../RTK/favourite';
import { selectIsFavourite } from '../RTK/favourite/selectors';
import userApi from '../Service/api/user';

import useCancellableRequest from './useCancellableRequest';
import useToast from './useToast';

type Favorite = (id: string) => {
  isLoading: boolean;
  isSaved: boolean;
  toggleFavourite: () => void;
};

const useFavorites: Favorite = (id) => {
  const { createRequest } = useCancellableRequest();
  const dispatch = useDispatch();
  const toast = useToast();
  const isSaved = useSelector((state) => selectIsFavourite(state, id));
  const [isLoading, setIsLoading] = useState(false);

  const _toggleFavourite = async () => {
    setIsLoading(true);
    const apiMethod = isSaved
      ? userApi.removeFromFavorite
      : userApi.addToFavorite;
    _showToast();
    const { ok, problem } = await createRequest(apiMethod, id);
    if (problem === CANCEL_ERROR) {
      return;
    }
    if (!ok) {
      _showToast('Failed to update your saved store please try again later.');
    }
    setIsLoading(false);
  };

  const _showToast = (errorMessage?: string) => {
    toast.hide();
    const savedMessage = 'Added to “My Favorites."';
    const removedMessage = 'Removed from "My Favorites."';
    toast.show(
      errorMessage || (isSaved ? removedMessage : savedMessage),
      errorMessage ? false : true,
    );
    setTimeout(() => {
      dispatch(toggleFavourite(id));
    }, 0); // for derering the dispatch on redux so it won't block the ui
  };

  return {
    isLoading,
    isSaved,
    toggleFavourite: _toggleFavourite,
  };
};

export default useFavorites;
